/* eslint-disable @typescript-eslint/naming-convention */
export enum  ModuleIcon {
      JOB = 'ti ti-briefcase font-normal  job-icon-color ',
      RECURRING_JOB = 'ti ti-briefcase font-normal  job-icon-color ',
      CUSTOMER = 'ti ti-users font-normal   text-primary-700 dark:text-on-primary ',
      ESTIMATE =  'ti ti-calculator font-normal  estimate-icon-color ',
      ESTIMATES =  'ti ti-calculator font-normal  estimate-icon-color ',
      INVOICE = 'ti ti-credit-card font-normal  invoice-icon-color ',
      SERVICE_CONTRACT = 'ti ti-file font-normal  service-contract-color ',
      SERVICE_CONTRACTS = 'ti ti-file font-normal  service-contract-color ',
      USER = 'ti ti-user  font-normal  user-icon-color ',
      PRODUCT= 'ti ti-tag font-normal   text-primary-700 dark:text-on-primary ',
      PRODUCTS= 'ti ti-tag font-normal   text-primary-700 dark:text-on-primary ',
      ASSET= 'ti ti-box font-normal  asset-icon-color ',
      ASSETS= 'ti ti-box font-normal  asset-icon-color ',
      BROADCAST= 'ti ti-speakerphone font-normal  broadcast-icon-color ',
      REPORT = 'ti ti-file-chart font-normal  report-icon-color ',
      ORGANIZATION = 'ti ti-building font-normal',
      PROPERTY = 'ti ti-building-community font-normal',
      REQUEST = 'ti ti-tools font-normal',
      TIMEOFF_REQUEST = 'ti ti-calendar font-normal asset-icon-color',
      PROJECT = 'ti ti-clipboard-check font-normal',
      NON_JOB_EVENT = 'ti ti-calendar font-normal job-icon-color ',
      ZUPER_CONNECT = 'ti ti-message-dots font-normal'
  }
